<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>普通问诊</a><i class="el-icon-arrow-right"></i><a>工作室列表</a><i class="el-icon-arrow-right"></i><a>工作室详情</a></p>
            </div>
        </div>
        <div class="contentRes"> 
            <div class="contentList">
                <div style="padding: 20px 30px;background: #FFFFFF;margin-top:10px">
                    <div class="contentListTop" style="margin-bottom:10px">
                        <div class="contentListLine"></div><span>工作室传承人</span>
                    </div>
                    <div class="contentListDocList" v-for="(item,index) in hosDocList1" :key="index">
                        <div class="contentListDocTop">
                            <div class="DocTopImgOrg">
                                <img v-if="item.photoFile " :src="http + item.photoFile" alt="" srcset="">
                                <img v-else src="../../assets/img/reservation/touxiang03.png" alt="">
                                <div class="DocTopTag1">传承人</div>
                            </div>
                            <div class="DocTopImgRorg">
                                <div class="DocTopImgRTorg">
                                    <span class="DocTopImgNameOrg">{{item.userName}}</span>
                                    <img v-if="item.certificateNumber" src="../../assets/img/reservation/ilabel.png" style="width:60px;height:18px" alt="" srcset="">
                                    <!-- <div v-if="item.levelName == 1" class="DocTopTagZ">{{item.levelName}}</div> -->
                                    <div v-if="item.userCategoryType == 1" class="DocTopTagZ">专家</div>
                                </div>
                                <div class="DocTopFlexC" style="font-size: 14px;color: #333333;">
                                    <span>{{item.hospitalDeptName}}</span>
                                    <span style="margin:0 5px">|</span>
                                    <span>{{item.userTitleName}}</span>
                                    <span style="margin:0 5px">|</span>
                                    <span>{{item.userPostName}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="desDocOrg" style="" v-if="item.expertise">擅长:{{item.expertise}}</div>
                        <div class="DocTopFlexB" style="margin-top:5px;font-size: 14px;color: #666666;">
                            <div>
                                <span style="margin-right:30px">问诊量： <span style="color:#00AFB5">{{item.orderCount}}</span></span>
                                <span style="margin-right:30px">好评率：<span style="color:#00AFB5">{{item.goodRate + '%'}}</span></span>
                                <span>评分：<span style="color:#00AFB5">{{item.starRate}}</span></span>
                            </div>
                        </div>
                        <div class='btnGreen' @click="goDocDetai(item)">查看详情</div>
                    </div>
                    <div v-if="hosDocList1.length == 0" style="margin-top:70px; display: flex;align-items: center;flex-direction: column;">
                        <img src="../../assets/img/consultation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                        <span style="color: #666666;">暂未找到符合条件的医生！</span>
                    </div>
                </div>
                <div style="padding: 0px 30px;background: #FFFFFF;">
                    <div class="contentListTop" style="margin-bottom:10px">
                        <span style="font-weight: bold;font-size: 18px;" >专科团队（师承）</span><span style="font-weight: 400;font-size: 14px;">在线/电话问诊专科医生</span>
                    </div>
                    <div class="contentListDocList" v-for="(item,index) in hosDocList0" :key="index">
                        <div class="contentListDocTop">
                            <div class="DocTopImgOrg">
                                <img v-if="item.photoFile " :src="http + item.photoFile" alt="" srcset="">
                                <img v-else src="../../assets/img/reservation/touxiang03.png" alt="">
                            </div>
                            <div class="DocTopImgRorg">
                                <div class="DocTopImgRTorg">
                                    <span class="DocTopImgNameOrg">{{item.userName}}</span>
                                    <img v-if="item.certificateNumber" src="../../assets/img/reservation/ilabel.png" style="width:60px;height:18px" alt="" srcset="">
                                    <!-- <div v-if="item.levelName == 1" class="DocTopTagZ">{{item.levelName}}</div> -->
                                    <div v-if="item.userCategoryType == 1" class="DocTopTagZ">专家</div>
                                </div>
                                <div class="DocTopFlexC" style="font-size: 14px;color: #333333;">
                                    <span>{{item.hospitalDeptName}}</span>
                                    <span style="margin:0 5px">|</span>
                                    <span>{{item.userTitleName}}</span>
                                    <span style="margin:0 5px">|</span>
                                    <span>{{item.userPostName}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="desDocOrg" style="" v-if="item.expertise">擅长:{{item.expertise}}</div>
                        <div class="DocTopFlexB" style="margin-top:5px;font-size: 14px;color: #666666;">
                            <div>
                                <span style="margin-right:30px">问诊量： <span style="color:#00AFB5">{{item.orderCount}}</span></span>
                                <span style="margin-right:30px">好评率：<span style="color:#00AFB5">{{item.goodRate + '%'}}</span></span>
                                <span>评分：<span style="color:#00AFB5">{{item.starRate}}</span></span>
                            </div>
                        </div>
                        <div class='btnGreen' @click="goDocDetai(item)">查看详情</div>
                    </div>
                    <div v-if="hosDocList0.length == 0" style="margin-top:70px; display: flex;align-items: center;flex-direction: column;">
                        <img src="../../assets/img/consultation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                        <span style="color: #666666;">暂未找到符合条件的医生！</span>
                    </div>
                </div>
            </div>
            <div style="">
                <div class="contentListRight">
                    <div style="margin: 19px 31px 28px 23px;padding-top:20px">
                        <div class="contentListTopR">
                            <div class="contentListLineR"></div><span>温馨提示</span>
                        </div>
                        <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                            本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ft-com></ft-com>
    </div>
</template>

<script>
import { reservationMain } from "../../components/reservation/reservation";
import { consultationMain } from "../../components/consultation/consultation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
export default {
    components: {
        hdCom,
        ftCom,
    },
    data() {
        var reservationMainItem = new reservationMain(this.TokenClient, this.Services.Authorization);
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        return {
            consultationDomain: consultationMainItem,
            reservationDomain: reservationMainItem,
            http:'',
            StuDataList:[],
            hosDocList:[],
            hosDocList0:[],
            hosDocList1:[],
            id:this.$route.query.id,
            hosOrgDetail:{}
        }
    },
    mounted(){
        this.http = this.Services.ossUpload;
        this.DoctorListData()
    },
    beforeDestroy() {
    },
    methods: {
        GetOrgDetialData(){
            var _this = this
            _this.reservationDomain.GetOrgDetial(_this.hosDocList[0].organizationId,function (data) {
                _this.hosOrgDetail = data.data
            },
            function (error) {
                 _this.hosOrgDetail = {}
                console.log('', error)
            })
        },
        goDocDetai(e){
            let params = {
                id:e.id,
                userName:e.userName,
                userCategoryType:e.userCategoryType,
                departmentName:e.departmentName,
                userPostName:e.userPostName,
                userTitleName:e.userTitleName,
                certificateNumber:e.certificateNumber,
                expertise:e.expertise,
                orgName:this.hosOrgDetail.name,
                specialtyTypeName:this.hosOrgDetail.specialtyTypeName,
                levelName:this.hosOrgDetail.level.name,
                orgRegionFullName:this.hosOrgDetail.address,
                photoFile: e.photoFile,
                onlineConsultationPrice:e.onlineConsultationPrice,
                phoneConsultationPrice:e.phoneConsultationPrice,
            }
            this.$router.push({
                path: "/reservation/reservationDoctorDetail",
                query: {
                    DocDetail: JSON.stringify(params),
                },
            });
        },
        //详情获取
        DoctorListData() {
            var _this = this;
            _this.hosDocList0=[]
            _this.hosDocList1=[]
            _this.consultationDomain.GetAppointmentDoctorListStu(_this.id, function (data) {
                _this.hosDocList = data.data
                _this.hosDocList.map((res)=>{
                    if (res.ifLeader == 0) {
                        _this.hosDocList0.push(res)
                    }
                    if (res.ifLeader == 1) {
                        _this.hosDocList1.push(res)
                    }
                })
                _this.GetOrgDetialData()
            },
            function (error) {
                 _this.hosDocList = []
                console.log('', error)
            })
        },
    },
}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.content {
  width: 1200px;
    margin: 0 auto;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.bannerImg {
    height: 150px;
    background: linear-gradient(90deg, #12C7AC, #00AFB5);
    border-radius: 6px 6px 0px 0px;
}
.bannerImg img {
    width: 330px;
    height: 120px;
    margin-left: 32px;
    margin-top: 20px;
}
.content-top {
  height: 64px;
  background: #ffffff;
  box-shadow: 2px 0 5px rgba(102, 102, 102, 0.08);
}
.diagnose-tab {
    padding: 20px 30px;
    padding-bottom: 0px;
    cursor: pointer;
    border-radius: 0px 0px 6px 6px;
}
.diagnose-tab span {
  margin-right: 50px;
  color: #808080;
  font-size: 16px;
   padding-bottom: 20px;
}

.diagnose-tab span.active {
  color: #00A8AE;
  border-bottom: 2px solid #00A8AE;
}
.contentList {
    margin-top: 20px;
    /* background: #FFFFFF; */
    width: 800px;

}
.contentListTop {
    display: flex;
    align-items: center;
}
.contentListTop3 {
    display: flex;
    align-items: center;
    position: relative;
     cursor: pointer;
}
.contentListLine {
    width: 3px;
    height: 20px;
    background: #00AFB5;
    border-radius: 2px;
}
.contentListTop span {
   font-size: 20px;
   margin-left: 10px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.contentListDoc {
    background: #F5FAF9;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    position: relative;
}
.contentListDocTop {
    display: flex;
    align-items: center;
}
.DocTopImg {
    width: 80px;
    height: 80px;
    position: relative;
}
.DocTopImg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.DocTopTag {
    width: 60px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.DocTopTag1 {
    width: 60px;
    background: #FB751B;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.DocTopImgR {
    margin-left: 16px;

}
.DocTopImgName {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 7px;
}
.DocTopTagZ {
    width: 40px;
    background: #677AEC;
    border-radius: 3px;
    font-size: 10px;
    color: #FFFFFF;
    text-align: center;
    margin-left: 7px;
}
.DocTopImgRT {
    display: flex;
    align-items: center;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexB {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btnGreen {
    width: 100px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    color: #FFFFFF;
    font-size: 16px;
    text-align: center;
    padding: 5px 0;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}
.desDoc{
    margin-top:10px;
    font-size: 16px;
    color: #666666;
    overflow: hidden;/*超出部分隐藏*/
    /* white-space: nowrap; */
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical
}
.DocTopImgOrg {
    width: 60px;
    height: 60px;
    position: relative;
}
.DocTopImgOrg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.DocTopImgRTorg  {
    display: flex;
    align-items: center;
}
.DocTopImgNameOrg {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 7px;
}
.contentListDocList {
    background: #F5FAF9;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    position: relative;
}
.DocTopImgRorg {
    margin-left: 16px;

}
.desDocOrg {
     margin-top:10px;
    font-size: 16px;
    color: #666666;
    overflow: hidden;/*超出部分隐藏*/
    /* white-space: nowrap; */
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical
}
</style>
